import { render, staticRenderFns } from "./RecipientsBiometry.vue?vue&type=template&id=d905098e&scoped=true"
import script from "./RecipientsBiometry.vue?vue&type=script&lang=js"
export * from "./RecipientsBiometry.vue?vue&type=script&lang=js"
import style0 from "./RecipientsBiometry.vue?vue&type=style&index=0&id=d905098e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d905098e",
  null
  
)

/* custom blocks */
import block0 from "./RecipientsBiometry.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports